import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { WorkflowStepNames } from '../../../constants/constants'
import Routes from '../../../constants/routes';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Icon from '../../Common/Icon';
import './SubscriptionDisclaimerWorkflowStep.scss';
import { Editor } from 'react-draft-wysiwyg';

class SubscriptionDisclaimerWorkflowStep extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false,
            isCanceled: false
        };
    }

    onContinueClick = () => {
        this.setState({ isLoading: true });
        this.props.userActions.acknowledgeWelcomeMessage(this.props.step.revisionId)
            .then(() => {
                // Don't complete the workflow step until the acknowledgement is successful
                this.props.accountActions.completeWorkflowStep(this.props.step.name);
            })
            .catch((error) => {
                Notification("error", "Error", error);
                this.setState({ isLoading: false });
            });
    }

    onCancelClick = () => {
        this.setState({ isCanceled: true });
    }

    render() {
        if (!this.props.user || !this.props.step || this.props.step.name !== WorkflowStepNames.SubscriptionDisclaimer) {
            Notification("error", "Error", "Invalid Step Name: Expected " + WorkflowStepNames.SubscriptionDisclaimer + " Actual: " + this.props.step.name);
            return (<Redirect to={Routes.LoginPage} />);
        }

        let jsonMessage = null;
        if (this.props.step.message) {
            try {
                jsonMessage = JSON.parse(this.props.step.message);
            } catch (error) {
                // Just skip the message acknowledgement as this is a v4 message in HTML
                // Will need to convert the HTML v4 messages to draftjs format somehow
                this.onContinueClick();
            }
        }

        return (
            <LoadingIndicator isLoading={this.state.isLoading} isFullscreen={false}>
                {
                    (this.state.isCanceled)
                        ?
                        <Redirect to={Routes.LoginPage} />
                        :
                        <div className="subscription-disclaimer-workflow-step">
                            <Editor
                                readOnly={true}
                                editorClassName="welcome-message"
                                defaultContentState={jsonMessage}
                            />
                            <div>
                                <button className="pacer-button" onClick={this.onContinueClick}>Continue<span><Icon name="arrow-right" /></span></button>
                            </div>
                            <div>
                                <button className="btn btn-link mt-2" onClick={this.onCancelClick}>Sign Out</button>
                            </div>
                        </div>
                }
            </LoadingIndicator>
        );
    }

}

SubscriptionDisclaimerWorkflowStep.propTypes = {
    step: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    accountActions: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired
};

export default SubscriptionDisclaimerWorkflowStep;